import { useEffect } from "react";
import type { HttpAgent } from "@ag-ui/client";

/**
 * Subscribes to AG-UI CUSTOM events named "conversation_name" from the agent
 * and calls the provided callback to update the conversation display name.
 *
 * Expected event shape:
 *   { type: "CUSTOM", name: "conversation_name", value: { display_name: "...", conversation_id: "..." } }
 */
export function useConversationName(
  agent: HttpAgent,
  onConversationName: (conversationId: string, displayName: string) => void
): void {
  useEffect(() => {
    const sub = agent.subscribe({
      onCustomEvent: ({ event }) => {
        if (event.name !== "conversation_name") {
          return;
        }
        const { display_name, conversation_id } = event.value ?? {};
        if (typeof display_name !== "string" || typeof conversation_id !== "string") {
          return;
        }

        onConversationName(conversation_id, display_name);
      },
    });

    return () => sub.unsubscribe();
  }, [agent, onConversationName]);
}
